import { Dispatch, Middleware, Store } from 'redux';
import Event from '../Event';

// tslint:disable:no-any
export interface EventGuardConfig<S = any> {
    type: string;
    validate: ((state: S, event: Event) => Event[]);
}

// tslint:disable-next-line:typedef
const eventGuard = <S>(eventToNotificationConfig: Array<EventGuardConfig<S>>): Middleware => (store: Store<S>) => (
    next: Dispatch<Event>
) => (event: Event): any => {
    const mappedEvent: Event[] = mapToEvent(store.getState(), eventToNotificationConfig, event);
    return mappedEvent.length > 0 ? mappedEvent.forEach(m => next(m)) : next(event);
};

const mapToEvent = <S>(state: S, eventToNotificationConfig: Array<EventGuardConfig<S>>, event: Event): Event[] => {
    const mapper: EventGuardConfig = eventToNotificationConfig.filter((config: EventGuardConfig<S>) => config.type === event.type)[0];
    if (mapper) {
        return mapper.validate(state, event);
    }
    return [];
};

export default eventGuard;



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventGuard.ts